// tslint:disable: semicolon
import React, { Component } from 'react';
import Message from './Message';
import { IChatMessageProps } from '../../../models';

class MessageList extends Component<IChatMessageProps> {
  messageListWrapper: React.RefObject<HTMLDivElement>;
  constructor(props: IChatMessageProps) {
    super(props);
    this.messageListWrapper = React.createRef();
  }
  componentDidUpdate = () => {
    this.messageListWrapper.current.scrollTop = this.messageListWrapper.current.scrollHeight;
  };

  render() {
    const { teacher, teacherName, onUpdateMessage } = this.props;
    return (
      <div className="MessageList" ref={this.messageListWrapper}>
        {this.props.messages.map((message, i) => (
          <Message
            key={i}
            message={message}
            isTeacher={teacher}
            onUpdateMessage={onUpdateMessage}
            teacherName={teacherName}
          />
        ))}
      </div>
    );
  }
}

export default MessageList;
